import React from "react";

export default function Footer() {
  return (
    <footer>
      <p>
        React / CSS Project
        <br />
        <strong>Made by Sergey Vozika</strong>
        <br />
        2022
        <br />
      </p>
    </footer>
  );
}
